export default "__VITE_ASSET__9b0c04cc__"